import { booleanToEnum } from './object-utils';


export function replaceItemByKey<T extends { }>(items: T[], newItem: T, idKey: keyof T) {
    return items.map(item => (item[idKey] === newItem[idKey] ? newItem : item));
}

export function replaceItemById<T extends { id: string | number }>(items: T[], newItem: T) {
    return replaceItemByKey(items, newItem, 'id');
}

export function removeItemByKey<T extends { [idKey: string]: string | number }>(
    items: T[], idKey: keyof T, idValue: string | number
) {
    return items.filter(item => item[idKey] !== idValue);
}

export function removeItemById<T extends { id: string | number }>(
    items: T[], idValue: string | number
) {
    return removeItemByKey(items, 'id', idValue);
}

export function tryGetItemByKey<T extends { }>(
    items: T[], idKey: keyof T, idValue: string | number
) {
    return (items as { [key: string]: string | number }[]).find(
        item => item[idKey] as string | number === idValue
    ) as T | undefined;
}

export function getItemByKey<T extends { }>(
    items: T[], idKey: keyof T, idValue: string | number
) {
    return tryGetItemByKey(items, idKey, idValue)!;
}

export function tryGetItemById<T extends { id: string | number }>(
    items: T[], idValue: string | number
) {
    return tryGetItemByKey(items, 'id', idValue);
}

export function getItemById<T extends { id: string | number }>(
    items: T[], idValue: string | number
) {
    return getItemByKey(items, 'id', idValue);
}

export function booleanObjectsToEnums<T extends Record<string, any>>(objects: T[]) {
    return objects.map(object => booleanToEnum(object));
}
